module.exports = __webpack_public_path__ + "img/Rectangle 158.8f798067.jpg";